import SearchableSelect from './SearchableSelect'
import { COUNTRIES } from '../lib/countries'

// Z91: the one country picker. ISO 3166-1 alpha-2 only, shown as "GB — United Kingdom" so typing
// "united" or "GB" both find it; GB/CN/HK/DE/NL/US/IT/ES/FR/PL are pinned first (list order).
// Value is always the 2-letter code; free typing is not accepted.
export default function CountrySelect({ value, onChange, disabled, placeholder = 'Select country…', invalid }: {
  value: string | null | undefined
  onChange: (code: string) => void
  disabled?: boolean
  placeholder?: string
  invalid?: boolean
}) {
  return (
    <SearchableSelect
      options={COUNTRIES}
      value={(value ?? '').toUpperCase()}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      invalid={invalid}
      usePortal
    />
  )
}
